import React from 'react';
import {configData} from "../../config.js";
import '../../styles.scss';
import {fetchSigned} from "../../shared/Utilities.js"
import AgreementList from "./AgreementList.js"

/**
 * Renders a selection control for agreements
 *
 * @copyright Roche 2024
 * @author Nick Draper
 */
class AgreementDisplayList extends React.Component {
  /**
   * Constructor 
   * 
   * @param props The properties passed
   */
  constructor(props) {
    super(props);
    this.state = {isLoaded:true,
      searchResults: [],
    };
  }

  /**
   * Runs once after construction after everything is initialised
   */
  componentDidMount() {
    this.loadSearchResults();
  }


  
  /** Runs whenever the properties of the control are changed
   * @param prevProps The previous properties dictionary
   * @param prevState The previous state dictionary
   */
  componentDidUpdate(prevProps, prevState) {
    let mustRefreshResults = false;

    if (this.props.selectedIdList !== prevProps.selectedIdList) {
      mustRefreshResults = true;
    }
    
    // we have been signalled to update
    if (mustRefreshResults) {
      this.loadSearchResults();
    }
  }

  loadSearchResults() {
    this.setState({
      isLoaded: false,
      error: null
    });
    //gather searchData
    const searchData = {
      searchBy: "Agreement ID",
      searchTerm: "'" + this.props.selectedIdList.join("','") + "'"
    };

    console.log(JSON.stringify(searchData));

    fetchSigned(configData.USECASE_API_URL + "agreement-search/", {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(searchData)
    })
      .then(res => res.json())
      .then(
        (result) => {
          console.log("RESULT",result);
          this.setState({
            isLoaded: true,      
            searchResults: result,
          });
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (errorMsg) => {
          this.setState({
            isLoaded: true,
            error: "Error Loading data uses cases" + errorMsg
          });
        }
      )
  }



  /**
   * Renders the controls
   * @returns The JSX of the controls
   */
  render() {    
    return (
      <AgreementList
        agreementList={this.state.searchResults}
        keyPrefix="AgreementDisplayList"
        title="Selected Agreements"
        showActionIcon={false}
        size={this.props.size}
        hideTitle={this.props.hideTitle}
      />
    );
  }

}

AgreementDisplayList.defaultProps = {
  selectedIdList: [],
  size: "medium",
  hideTitle: false
}

export default AgreementDisplayList;
